import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { ISetSubscriptionsFormatParams } from '../types/actionParams';

export class SetSubscriptionsFormatRequest extends Request<ISetSubscriptionsFormatParams, IEmptyResult> {
  constructor(params: ISetSubscriptionsFormatParams) {
    super('setSubscriptionsFormat', params);
  }
}
